import { DEFAULT_DESCRIPTION, SITE_NAME } from './site';

export const PAGE_SEO = {
  '/': {
    title: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    breadcrumb: 'Home',
  },
  '/meet-lisa': {
    title: 'Meet Lisa',
    description:
      'Meet Lisa Marsh, Certified Integrated Health Practitioner serving Owen Sound and area with personalized wellness coaching.',
    breadcrumb: 'Meet Lisa',
  },
  '/services': {
    title: 'Services',
    description:
      'Explore integrated health services including wellness coaching, detox guidance, supplement support, and tailored natural wellness plans.',
    breadcrumb: 'Services',
  },
  '/faq': {
    title: 'FAQ',
    description:
      'Answers to common questions about consultations, health coaching, and integrated health practitioner services at Roots to Wellness.',
    breadcrumb: 'FAQ',
  },
  '/contact': {
    title: 'Contact',
    description:
      'Contact Lisa Marsh at Roots to Wellness in Owen Sound, Ontario to request a consultation or ask a question.',
    breadcrumb: 'Contact',
  },
  '/functional-labs': {
    title: 'Functional Labs',
    description:
      'Learn about functional lab testing options for gut health, food sensitivities, hormones, inflammation, and related wellness markers.',
    breadcrumb: 'Functional Labs',
  },
  '/my-roots-to-wellness-journey': {
    title: 'My Roots to Wellness Journey',
    description:
      "Read Lisa Marsh's personal roots-to-wellness journey and how it shaped her integrated health practice.",
    breadcrumb: 'My Journey',
  },
};

export function getPageSeo(pathname) {
  return PAGE_SEO[pathname] ?? null;
}

export function formatDocumentTitle(pageTitle) {
  if (!pageTitle || pageTitle === SITE_NAME) {
    return `${SITE_NAME} | Integrated Health Practitioner`;
  }

  return `${pageTitle} | ${SITE_NAME}`;
}
